import AttrField from '@SidePanel/Fields/AttrField';
import FileField from '@SidePanel/Fields/FileField';
import { Box } from '@mui/material';

function UploadImage({ height, path }) {
    return (
        <Box
            sx={{
                height,
                p: 2,
            }}
        >
            <Box sx={{ pointerEvents: 'auto', height: '100%' }}>
                <AttrField
                    Component={FileField}
                    name="src"
                    sx={{ height: '100%' }}
                    path={path}
                />
            </Box>
        </Box>
    );
}

export default UploadImage;
